import React from 'react'

function Version() {
  return (
       <span>
        V 5.3.4
        </span>
    
  )
}

export default Version